<template>
  <section class="card-voucher__index column-index">
    <change-store></change-store>
    <column-info :column-list="[getCouponColumns]"></column-info>
    <column-info :column-list="[getMarketingColumns]"></column-info>
    <column-info v-if="authList.includes(authApi.busiAnalysis[utilColumn.authName])" :column-list="[utilColumn]"></column-info>
    <column-info v-if="authList.includes(authApi.busiAnalysis[statisticalColumn.authName])"  :column-list="[statisticalColumn]"></column-info>
  </section>
</template>

<script>
import ChangeStore from '../components/ChangeStore'
import ColumnInfo from '../components/ColumnInfo'
import authApi from '../../common/auth'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    ChangeStore,
    ColumnInfo
  },
  data() {
    return {
      invitationConfig: {
        is_opened: false
      },
      couponColumn: {
        title: '卡券',
        items: [
          {
            name: '领券码',
            icon: 'coupon-QR',
            link: '/coupon/index'
          },
          {
            name: '卡券审核',
            icon: 'card-check',
            link: '/cardCheck/check'
          },
          {
            name: '卡券核销',
            icon: 'audit-verification',
            link: '/cou_ver'
          }
        ]
      },
      marketingColumn: {
        title: '营销活动',
        items: [
          {
            name: '集客报名',
            icon: 'activity-center',
            link: '/marketing/activityCenter'
          },
          {
            name: '转介绍',
            icon: 'referral',
            link: '/marketing/referral'
          }
        ]
      },
      utilColumn: {
        title: '小工具',
        authName: 'store_manage_profile',
        items: [
          {
            name: '客餐排队',
            icon: 'guest_meals_online',
            link: '/tool/guestMeals'
          }
        ]
      },
      statisticalColumn: {
        title: '数据统计',
        authName: 'fans_analysis',
        items: [
          {
            name: '粉丝统计',
            icon: 'vermicelli-statistics',
            link: '/manageAnalysis/fansAnalysis'
          }
        ]
      },
      authList: []
    }
  },
  created () {
    this.getColumnAuth()
    this.getInvitationConfig()
  },
  methods: {
    async getColumnAuth () {
      const { authList } = await this.$store.state.promiseAuth
      this.authList = authList
    },

    async getInvitationConfig() {
      const { code, data } = await this.$rest.marketing.getInvitationConfig()
      if (code !== 0) return
      this.invitationConfig = { ...this.invitationConfig, ...data }
    }
  },
  computed: {
    columnList () {
      return this.defaultColumns.filter(column => column.hasAuth === true)
    },
    authApi() {
      return authApi
    },
    getMarketingColumns() {
      const column = cloneDeep(this.marketingColumn)
      if (!this.invitationConfig.is_opened) {
        column.items = column.items.filter(item => item.icon !== 'referral')
      }
      return column
    },
    getCouponColumns() {
      const column = cloneDeep(this.couponColumn)
      column.items = column.items.filter(item => {
        return !item.authName || this.authList.includes(item.authName)
      })
      return column
    }
  }
}
</script>

<style lang="less">
  @import "../../stylesheets/base/fn.less";
  @import "../../stylesheets/modules/manage/columnList.less";
  .card-voucher__index {
    .column {
      @selectors:
        coupon-QR,
        card-check,
        audit-verification,
        guest_meals_online,
        vermicelli-statistics,
        activity-center,
        referral;
      each(@selectors, {
        .@{value} {
          background: url('../../stylesheets/images/index/@{value}.png') no-repeat center center / cover;
          background-size: contain;
        }
      })
    }
  }
</style>
